<template>
  <V2Modal
    :show="show"
    :title="modalTitle"
    size="lg"
    @close="closeSelectStoresPopup"
  >
    <V2StoresList
      :cart-values-list="storeList"
      :show-only-list="showOnlyList"
      @update-selected-stores="onSelectedStores"
    />

    <!-- Order Details (shown for place-order flow) -->
    <div
      v-if="showOrderDetails && selectedStores.length"
      class="v2-select-stores-order-details"
    >
      <div class="v2-select-stores-order-details__title">
        Order details
      </div>
      <div class="v2-select-stores-order-details__rows">
        <div class="v2-select-stores-order-details__row">
          <span>Total units</span>
          <span>{{ formatNumber(totalOrderValue.totalCartsUnits) || 0 }}</span>
        </div>
        <div class="v2-select-stores-order-details__row">
          <span>Total costs</span>
          <span>{{ formatCurrency(Number(totalOrderValue.totalCartsValue), totalOrderValue.currency) }}</span>
        </div>
        <div class="v2-select-stores-order-details__row">
          <span>Total RRP</span>
          <span>{{ formatCurrency(Number(totalOrderValue.totalCartsRRP), totalOrderValue.currency) }}</span>
        </div>
        <div class="v2-select-stores-order-details__divider" />
        <div class="v2-select-stores-order-details__row v2-select-stores-order-details__row--bold">
          <span>Total</span>
          <span>{{ formatCurrency(Number(totalOrderValue.totalCartsValue), totalOrderValue.currency) }}</span>
        </div>
      </div>
    </div>

    <template #footer>
      <V2Button
        variant="outline"
        @click="closeSelectStoresPopup"
      >
        Cancel
      </V2Button>
      <V2Button
        variant="primary"
        :disabled="isDownloading || selectedStores.length === 0"
        :loading="isDownloading"
        @click="onClickDownload"
      >
        {{ isDownloading ? 'Downloading...' : okBtnText }}
      </V2Button>
    </template>
  </V2Modal>
</template>

<script>
import { constants as c, utils } from '@kingpin-global/kingpin-utils-frontend'
import { formatNumber } from '@/@core/utils/utils'
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import V2StoresList from './V2StoresList.vue'

const { formatCurrency } = utils
const { CURRENCY_CONVERSIONS } = c

export default {
  name: 'V2SelectStoresModal',
  components: {
    V2Modal,
    V2Button,
    V2StoresList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: 'Select stores',
    },
    okBtnText: {
      type: String,
      default: 'Download',
    },
    storeList: {
      type: Array,
      required: true,
    },
    isDownloading: {
      type: Boolean,
      default: false,
    },
    showOnlyList: {
      type: Boolean,
      default: false,
    },
    showOrderDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedStores: [],
      totalOrderValue: {
        totalCartsValue: 0,
        totalCartsUnits: 0,
        totalCartsRRP: 0,
        currency: CURRENCY_CONVERSIONS.USD.SYMBOL,
      },
      formatCurrency,
      formatNumber,
    }
  },
  methods: {
    closeSelectStoresPopup() {
      this.selectedStores = []
      this.$emit('on-close-modal')
    },
    onSelectedStores(list) {
      this.$emit('on-change-stores', list)
      this.selectedStores = list
      if (this.showOrderDetails) {
        this.calculateTotalValues(list)
      }
    },
    calculateTotalValues(list) {
      this.totalOrderValue.currency = list[0]?.currency || CURRENCY_CONVERSIONS.USD.SYMBOL
      this.totalOrderValue.totalCartsValue = list.reduce((acc, val) => acc + Number(val.totalValues), 0)
      this.totalOrderValue.totalCartsUnits = list.reduce((acc, val) => acc + Number(val.totalUnits), 0)
      this.totalOrderValue.totalCartsRRP = list.reduce((acc, val) => acc + Number(val.totalRRP), 0)
    },
    onClickDownload() {
      this.$emit('on-click-download', this.selectedStores)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-select-stores-order-details {
  background: var(--v2-muted);
  border-radius: var(--v2-radius-lg);
  padding: 1rem;
  margin-top: 1rem;

  &__title {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--v2-foreground);
    font-family: var(--v2-font-display);
    margin-bottom: 0.75rem;
  }

  &__rows {
    display: flex;
    flex-direction: column;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    color: var(--v2-muted-foreground);
    padding: 0.375rem 0;

    span:last-child {
      color: var(--v2-foreground);
      font-weight: 500;
    }

    &--bold {
      font-size: 1rem;
      font-weight: 700;

      span {
        color: var(--v2-foreground) !important;
      }
    }
  }

  &__divider {
    height: 1px;
    background: var(--v2-border);
    margin: 0.5rem 0;
  }
}
</style>
